import { render, staticRenderFns } from "./kh_name.vue?vue&type=template&id=dec83146&"
import script from "./kh_name.vue?vue&type=script&lang=js&"
export * from "./kh_name.vue?vue&type=script&lang=js&"
import style0 from "./kh_name.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports